import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../../config';

@Injectable()
export class VideozapisiPopisService {

  constructor(private _http: Http) { }

  dodajVideo(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'spremi_video', a)
    .map(res => res.json());
  }

  dohvatiSve(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_sve_video_materijale', a)
    .map(res => res.json());
  }

  urediVideo(a: any){
    return this._http.put(AppConfig.apiAdresaSQL + 'uredi_video', a)
    .map(res => res.json()); 
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/videozapisi-popis/videozapisi-popis.service.ts